import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "go_to_node",
  "use": "go_to_node-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"go_to_node\"><path d=\"M13.5 11.57c0 1.07-.86 1.93-1.93 1.93H6.43c-1.07 0-1.93-.86-1.93-1.93V6.43c0-1.07.86-1.93 1.93-1.93h.07C7.33 4.5 8 3.83 8 3H6.43C4.54 3 3 4.54 3 6.43v5.14C3 13.47 4.54 15 6.43 15h5.14c1.9 0 3.43-1.54 3.43-3.43V10c-.83 0-1.5.67-1.5 1.5zM10 3c-.41 0-.75.34-.75.75s.34.75.75.75h2.44L8.97 7.97c-.29.29-.29.77 0 1.06.15.15.34.22.53.22s.38-.07.53-.22l3.47-3.47V8c0 .41.34.75.75.75S15 8.41 15 8V3z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol